import { Tenant } from '@allbesmart/web-app-common';
import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { first, Subscription } from 'rxjs';
import { AvailableRoutes } from 'src/app/enums/available-routes';
import { UserDto } from 'src/app/models/user/create-user-dto';
import { TenantManagementService } from 'src/app/services/tenant-management.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UserRowComponent } from '../../components/user-row/user-row.component';

@Component({
    selector: 'oaibox-users-page',
    templateUrl: './users-page.component.html',
    styleUrl: './users-page.component.css',
    imports: [
        ReactiveFormsModule,
        FormsModule,
        UserRowComponent,
    ],
})
export class UsersPageComponent implements OnDestroy {

  protected keyword: string = "";

  protected tenantsMap: { [id: string]: Tenant } = {};

  protected shownUsers: UserDto[] = [];
  private users: UserDto[] = [];

  private usersSubscription: Subscription;
  private tenantsSubscription: Subscription;

  constructor(
    usersManagementService: UserManagementService,
    tenantManagementService: TenantManagementService,
    private router: Router
  ) {
    this.usersSubscription = usersManagementService.getUsers$()
      .subscribe(users => {
        this.users = [...users];
        this.filterMatchingUsers();
      });
    usersManagementService.refreshUsers();
    
    this.tenantsSubscription = tenantManagementService.getTenants$()
        .pipe(first())
        .subscribe(tenants => {
          this.tenantsMap = tenants.reduce((map, tenant) => {
            map[tenant.id] = tenant;
            return map;
          }, {} as {[id: string]: Tenant})
        });
    tenantManagementService.refreshTenants();
  }

  public filterMatchingUsers(): void {
    this.shownUsers = [...this.users];

    if (this.keyword.trim() !== '') this.filterUsers();
    this.sortUsers();
  }

  private filterUsers(): void {
      const keywordLower = this.keyword.trim().toLowerCase();
      this.shownUsers = this.shownUsers
      .filter((release: UserDto) => release.userEmail?.includes(keywordLower));
    }

  private sortUsers(): void {
    const sortFn = (a: UserDto, b: UserDto) => {
      if (!a.userEmail || !b.userEmail) return 0;
      if (a.userEmail < b.userEmail) return -1;
      if (a.userEmail > b.userEmail) return 1;
      return 0;
    };
    this.shownUsers.sort(sortFn);
  }

  protected goToNewUserPage(): void {
    this.router.navigate([AvailableRoutes.NEW_USER]);
  }

  ngOnDestroy(): void {
    this.usersSubscription.unsubscribe();
    this.tenantsSubscription.unsubscribe();
  }
}
